

















import { Component, Vue } from 'vue-property-decorator';
import moment from "moment";

@Component({
  components: {

  },
})
export default class Footer extends Vue {
  private year:string = moment().format('YYYY');
}
